import { motion } from 'framer-motion'
import { OverlayProps } from '../types'

export const Overlay = ({ onClose }: OverlayProps) => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.2 }}
    style={{ pointerEvents: 'auto' }}
    className='fixed bottom-0 left-0 right-0 top-0 z-[9997] h-full w-full bg-black/90 backdrop-blur-sm'
    onClick={onClose}
  />
) 